import { defineMessages } from 'react-intl';

export default defineMessages({
  reference: {
    id: 'components.myaccount.multiProduct.reference',
    defaultMessage: 'Réference : {value}',
  },
});
